/**
 * Makes images embedded in the "Product details" section's rich-text
 * description tappable, opening a full-resolution view in a modal — instead
 * of shrinking a wide spec/size-chart image down to an illegible thumbnail
 * on mobile. Reuses the theme's existing generic <modal-opener>/<modal-dialog>
 * custom elements (see assets/global.js), not the product-media gallery
 * lightbox, since these images aren't part of product.media.
 *
 * <modal-opener>'s constructor synchronously looks for a <button> child the
 * instant the element is created/upgraded, so the button must already exist
 * in the markup passed to insertAdjacentHTML — building it via
 * document.createElement + appendChild afterwards is too late and the
 * opener never finds a button to attach its click listener to.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-zoom-modal]').forEach((container) => {
    const modalSelector = container.getAttribute('data-zoom-modal');
    const modal = modalSelector && document.querySelector(modalSelector);
    const modalImage = modal && modal.querySelector('.product-details__zoom-image');

    if (!modal || !modalImage) return;

    container.querySelectorAll('img').forEach((img) => {
      if (img.closest('button')) return;

      img.insertAdjacentHTML(
        'beforebegin',
        `<modal-opener data-modal="${modalSelector}"><button type="button" class="product-details__zoom-button" aria-label="Zoom image"></button></modal-opener>`
      );

      const button = img.previousElementSibling.querySelector('button');
      button.appendChild(img);

      button.addEventListener('click', () => {
        modalImage.src = img.currentSrc || img.src;
        modalImage.alt = img.alt || '';
      });
    });
  });
});
